const RATING_SCALE_DEFAULT_LABELS = Object.freeze([
  Object.freeze({ text: 'Strongly disagree' }),
  Object.freeze({ text: 'Strongly agree' }),
]);

export const CLOSE_ENDED_DEFAULT_ANSWERS = Object.freeze([
  Object.freeze({ text: '', comments: false }),
  Object.freeze({ text: '', comments: false }),
]);

const NPS_DEFAULT_LABELS = Object.freeze([
  Object.freeze({ text: 'Not likely at all' }),
  Object.freeze({ text: 'Extremely likely' }),
]);

const REACTION_DEFAULT_LABELS = Object.freeze([
  Object.freeze({ text: 'Not good at all' }),
  Object.freeze({ text: 'Very good' }),
]);

// @todo update question types when merged to Question component PR
export const DEFAULT_LABELS_BY_TYPE = {
  'net-promoter-score': {
    labels: NPS_DEFAULT_LABELS,
  },
  'rating-scale-5': {
    labels: RATING_SCALE_DEFAULT_LABELS,
    scaleCount: 5,
  },
  'rating-scale-7': {
    labels: RATING_SCALE_DEFAULT_LABELS,
    scaleCount: 7,
  },
  reaction: {
    labels: REACTION_DEFAULT_LABELS,
    scaleCount: 5,
  },
};
